import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {Grid, TextField} from "@mui/material";
import {UsuarioInfoTextField} from "@components/contas/usuario/UsuarioInfoTextField.tsx";
import {DateTimeField} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {useCcDistribuibuivel} from "@components/contaContabil/valoresDistribuiveis/useCcDistribuibuivel.ts";
import {useState} from "react";

interface CcDistribuivelInfoProps extends Omit<DefaultInfoV1Props<ICcValorDistribuivel>, 'variant' | 'EndComponent'> {

}

export function CcDistribuivelGrid(props: CcDistribuivelInfoProps) {
    const {value, expectedId} = props
    const {getCcValorDistribuivelById} = useCcDistribuibuivel()
    const [v, setV] = useState<ICcValorDistribuivel | null>(value)
    if (v == null) {
        if (expectedId == null)
            return <>Valor indefinido...</>

        getCcValorDistribuivelById(expectedId).then(x => {
            setV(x)
        })
    }


    return (v != null && <Grid container>
        <Grid size={2}> <TextField label={'Id'} value={v.id} disabled/> </Grid>
        <Grid size={10}> <TextField label={'Descritivo'} value={v.nome}/> </Grid>
        <Grid size={6}><TextField label={'Valor'} value={v.valor}/> </Grid>
        <Grid size={6}> <TextField label={'Status'} value={v.status}/> </Grid>
        <Grid size={6}> <UsuarioInfoTextField displayValue={x => x.nome}
                                              label={'Criado por'}
                                              refId={v.usuarioCriacaoId}/>
        </Grid>
        <Grid size={6}><DateTimeField label={"Criado em"} fullWidth disabled
                                      value={dayjs(v.dataCriacao)}/></Grid>
        {v.usuarioAlteracaoId != null && <>
            <Grid size={6}>
                <UsuarioInfoTextField displayValue={x => x.nome}
                                      label={'Criado por'}
                                      refId={v.usuarioAlteracaoId}/>
            </Grid>
            <Grid size={6}>
                <DateTimeField label={"Alterado em"} fullWidth disabled
                               value={dayjs(v.dataAlteracao)}
                />
            </Grid>
        </>}
    </Grid>)
}